import { render, staticRenderFns } from "./OnboardingScreen.vue?vue&type=template&id=a359f45c&scoped=true&"
import script from "./OnboardingScreen.vue?vue&type=script&lang=js&"
export * from "./OnboardingScreen.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingScreen.vue?vue&type=style&index=0&id=a359f45c&prod&lang=scss&scoped=true&"
import style1 from "./OnboardingScreen.vue?vue&type=style&index=1&id=a359f45c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a359f45c",
  null
  
)

export default component.exports